document.addEventListener('DOMContentLoaded', function() {
  let cards = document.querySelectorAll('.dropdown-cards__card');
  let isMobile = window.innerWidth <= 991;
  let cardsContainer = document.querySelector('.dropdown-cards__wrapper');
  cards[0].classList.add('active');

  function handleDesktopEvents() {
    cards.forEach(card => {
      card.addEventListener('mouseenter', cardHoverHandler);
    });
    if (cardsContainer) {
      cardsContainer.addEventListener('mouseleave', containerLeaveHandler);
    }
  }

  function removeDesktopEvents() {
    cards.forEach(card => {
      card.removeEventListener('mouseenter', cardHoverHandler);
    });
    if (cardsContainer) {
      cardsContainer.removeEventListener('mouseleave', containerLeaveHandler);
    }
  }
  
  
  function initializeCards() {
    cards.forEach(card => {
      const contentContainer = card.querySelector('.dropdown-cards__card-content');
      const content = card.querySelector('.dropdown-cards__card-content p');
      if (content && contentContainer) {
        content.dataset.scrollHeight = content.scrollHeight + 'px';
        content.style.transition = 'max-height 0.8s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.8s ease';
        content.style.paddingTop = '12px';
        
        if (!card.classList.contains('active')) {
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
          content.style.paddingTop = '0px';
        }
      }
    });
  }
  
  function addCardListeners() {
    cards.forEach(card => {
      card.addEventListener('click', cardClickHandler);
    });
  }
  
  
  function removeCardListeners() {
    cards.forEach(card => {
      card.removeEventListener('click', cardClickHandler);
      
      
      const contentContainer = card.querySelector('.dropdown-cards__card-content');
      const content = card.querySelector('.dropdown-cards__card-content p');
      const closeIcon = card.querySelector('.dropdown-cards__card-header-close');
      
      if (content && contentContainer) {
        content.style.maxHeight = '';
        content.style.opacity = '';
        content.style.transition = '';
        contentContainer.style.transition = '';
      }
      
      if (closeIcon) {
        closeIcon.style.transform = '';
      }
      
      card.classList.remove('active');
    });
  }
  
  function cardHoverHandler(e) {
    if (window.innerWidth <= 991) return;
    
    const card = this;
    
    cards.forEach(otherCard => {
      if (otherCard !== card) {
        otherCard.classList.remove('active');
        const content = otherCard.querySelector('.dropdown-cards__card-content p');
        if (content) {
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
          content.style.paddingTop = '0px';
        }
      }
    });

    card.classList.add('active');
    const content = card.querySelector('.dropdown-cards__card-content p');
    if (content) {
      content.style.maxHeight = content.dataset.scrollHeight || '1000px';
      content.style.opacity = '1';
      content.style.paddingTop = '12px';
    }
  }

  function containerLeaveHandler(e) {
    if (window.innerWidth <= 991) return;
    
    cards.forEach((card, index) => {
      if (index === 0) {
        card.classList.add('active');
        const content = card.querySelector('.dropdown-cards__card-content p');
        if (content) {
          content.style.maxHeight = content.dataset.scrollHeight || '1000px';
          content.style.opacity = '1';
          content.style.paddingTop = '12px';
        }
      } else {
        card.classList.remove('active');
        const content = card.querySelector('.dropdown-cards__card-content p');
        if (content) {
          content.style.maxHeight = '0px';
          content.style.opacity = '0';
          content.style.paddingTop = '0px';
        }
      }
    });
  }

  function cardClickHandler(e) {
    const card = this;
    const contentContainer = card.querySelector('.dropdown-cards__card-content');
    const content = card.querySelector('.dropdown-cards__card-content p');
    const closeIcon = card.querySelector('.dropdown-cards__card-header-close');
    
    if (card.classList.contains('active')) {
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
      content.style.paddingTop = '0px';
      if (closeIcon) {
        closeIcon.style.transform = 'rotate(180deg)';
      }

        card.classList.remove('active');
        cards[0].classList.add('active');
  
      return;
    }
    
    removeActive();
    
    card.classList.add('active');
    content.style.maxHeight = content.dataset.scrollHeight || '1000px';
    content.style.opacity = '1';
    content.style.paddingTop = '12px';
    
    if (closeIcon) {
      closeIcon.style.transform = 'rotate(0deg)';
    }
  }

  function removeActive() {
    cards.forEach(card => {
      if (!card.classList.contains('active')) return;
      
      const contentContainer = card.querySelector('.dropdown-cards__card-content');
      const content = card.querySelector('.dropdown-cards__card-content p');
      const closeIcon = card.querySelector('.dropdown-cards__card-header-close');
      
      if (content && contentContainer) {
        content.style.maxHeight = '0px';
        content.style.opacity = '0';
        content.style.paddingTop = '0px';
      }
      
      if (closeIcon) {
        closeIcon.style.transform = 'rotate(180deg)';
      }
      
      setTimeout(() => {
        card.classList.remove('active');
      }, 600);
    });
  }
   
  function handleWindowResize() {
    const newIsMobile = window.innerWidth <= 990;
    
    if (newIsMobile !== isMobile) {
      isMobile = newIsMobile;
    
      if (isMobile) {
        initializeCards();
        addCardListeners();
      } else {
        removeCardListeners();
      }
    }
  }
  
  if (isMobile) {
    initializeCards();
    addCardListeners();
    removeDesktopEvents();
  } else {
    initializeCards();
    handleDesktopEvents();
  }
  
  window.addEventListener('resize', handleWindowResize);
});
